import { Divider, Grid, Typography } from "@material-ui/core";
import React, { useCallback } from "react";
import ProgressPlan from "views/JobDetailPage/Report/components/ProgressPlan";
import LeftReportContent from "./LeftReportContent";
import ResultWorking from "./ResultWorking";
import Scrollbars from "components/Scrollbars";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClearIcon from "@mui/icons-material/Clear";
import SortIcon from "@mui/icons-material/Sort";
import SettingsIcon from "@mui/icons-material/Settings";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import "./WrapperReport.scss";
import { useTranslation } from "react-i18next";
import { TimeRangePopover, useTimes } from "components/CustomPopover";
import { makeStyles } from "@material-ui/core/styles";
import NumberReport from "./NumberReport";
import ChartGroup from "./ChartGroup";
import ChartTask from "./ChartTask";
import ChartMember from "./ChartMember";
import ReportGroupCreation from "./ReportGroupCreation";
import ReportOrder from "./ReportOrder";
import ReportCreation from "./ReportCreation/ReportCreation";
import ReportProject from "./ReportProject";
import ReportSetting from "./ReportSetting";
import { Box, Button } from "@mui/material";
import moment from "moment";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  selectOpenReportGroupCreate,
  selectReportCategories,
  selectReportData,
  selectStatusDefaultCategory,
} from "../controllers/selectors";
import {
  getReportCategoriesSuccess,
  openCreateGroupReport,
} from "../controllers/actions";
import { useParams } from "react-router-dom";
import AssessmentIcon from "@mui/icons-material/Assessment";
import InfiniteScroll from "react-infinite-scroller";
import { viewPermissionsSelector } from "views/ProjectPage/selectors";

export const useStyles = makeStyles({
  btnNewReport: {
    textTransform: "none",
    padding: "8px 16px",
    maxHeight: 38,
    fontSize: "14px !important",
  },
  selectRangeTime: {
    textTransform: "none",
    padding: "8px",
    backgroundColor: "#ebedef",
    margin: "0px 3px",
    fontWeight: "normal",
  },
  btnAction: {
    textTransform: "none",
    margin: "0px 3px",
    backgroundColor: "#ebedef !important",
    padding: "10px 0px !important",
    minWidth: "50px !important",
    width: "50px !important",
    maxWidth: "50px",
    fontWeight: "normal",
    "&:hover": {
      backgroundColor: "#e5e5e5 !important",
    },
  },
  customDivider: {
    width: "100%",
    margin: "20px 0px",
  },
});
const StyledScrollbars = ({ className = "", height, ...props }) => (
  <Scrollbars className={`wrapper-report ${className}`} {...props} />
);

const WrapperReport = ({ report, project, viewPermissions }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [timeAnchor, setTimeAnchor] = React.useState(null);
  const times = useTimes();
  const [timeFilterReport, setTimeFilterReport] = React.useState({
    timeOption: -1,
  });
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const [openOrderModal, setOpenOrderModal] = React.useState(false);
  const [toggleSetting, setToggleSetting] = React.useState(false);
  const colors = useSelector((state) => state.setting.colors);
  const bgColor = colors.find((item) => item.selected === true);
  const reportCategories = useSelector(selectReportCategories());
  const statusDefaultCategory = useSelector(selectStatusDefaultCategory());
  const [selectedCategory, setSelectedCategory] = React.useState(undefined);
  const openReportGroupCreate = useSelector(selectOpenReportGroupCreate());
  const setOpenReportGroupCreate = (e) => {
    dispatch(openCreateGroupReport(e));
  };
  const [limit, setLimit] = React.useState(2);

  const heightTopBar = React.useMemo(() => {
    const topBar = document.getElementById("project-topbar");
    return topBar?.clientHeight || 0;
  }, []);
  const sxButton = {
    boxShadow: "none !important",
    backgroundColor: "#0076f3 !important",
    textTransform: "none",
    margin: "0px 5px",
  };
  const sxButtonSecondary = {
    ...sxButton,
    backgroundColor: "#f4f4f4",
    color: "#666",
  };
  const loading = () => {};
  console.log(reportCategories, "reportCategories");
  const isWebview = document.location.pathname.search("webview") !== -1;
  const canUpdate =
    viewPermissions?.permissions?.[projectId]?.update_project ?? false;
  return (
    <Box
      sx={{
        ...(document.location.pathname.search("webview/report") !== -1 && {
          "& .wrapper-report": {
            height: "100vh !important",
          },
        }),
      }}
    >
      <StyledScrollbars
        autoHide
        style={{
          marginBottom: 0,
        }}
        // height="tail"
      >
        <Grid
          className="wrapper-report-container"
          container
          direction="column"
          style={{
            maxHeight: `calc(100vh - ${heightTopBar}px)`,
          }}
        >
          <Grid
            container
            justifyContent="space-between"
            direction="row"
            style={{ marginTop: 5 }}
          >
            {canUpdate && !isWebview ? (
              <Button
                variant="contained"
                color="primary"
                className={classes.btnNewReport}
                onClick={() => {
                  setOpenReportGroupCreate(true);
                  setSelectedCategory(undefined);
                }}
                sx={{
                  ...sxButton,
                  marginLeft: 0,
                }}
              >
                <AddIcon className={classes.iconButton} />
                {t("views.report_page.CREATE_GROUP_REPORT")}
              </Button>
            ) : (
              <div style={{ width: "250px" }} />
            )}
            <Grid item justifyContent="space-between" style={{ marginTop: 5 }}>
              <Grid container justifyContent="space-between">
                {/* <Button
                className={classes.selectRangeTime}
                sx={sxButtonSecondary}
              >
                <Box onClick={(e) => setTimeAnchor(e.target)}>
                  {timeFilterReport.timeOption === -1 &&
                    t("views.report_page.FILTER_TIME")}
                  {timeFilterReport.timeOption !== -1 &&
                    `${moment(timeFilterReport.start).format(
                      timeFilterReport.timeOption === 6 ? "DD/MM/YYYY" : "DD/MM"
                    )} - ${moment(timeFilterReport.end).format("DD/MM/YYYY")}`}
                </Box>
                {timeFilterReport.timeOption !== -1 && (
                  <ClearIcon
                    onClick={(e) => {
                      e.preventDefault();
                      setTimeFilterReport({
                        timeOption: -1,
                        start: undefined,
                        end: undefined,
                      });
                    }}
                  />
                )}
                <ArrowDropDownIcon />
              </Button> */}
                <Button
                  className={classes.btnAction}
                  onClick={() => setOpenOrderModal(true)}
                  sx={sxButtonSecondary}
                >
                  <SortIcon className={classes.iconColor} />
                </Button>
                <Button
                  className={classes.btnAction}
                  onClick={() => setToggleSetting(!toggleSetting)}
                  sx={{
                    ...sxButtonSecondary,
                    marginRight: 0,
                  }}
                >
                  {!toggleSetting && (
                    <SettingsIcon className={classes.iconColor} />
                  )}
                  {toggleSetting && (
                    <AssessmentIcon className={classes.iconColor} />
                  )}
                </Button>
              </Grid>
            </Grid>
            <Divider className={classes.customDivider} />
            {toggleSetting ? (
              <ReportSetting
                projectId={projectId}
                handleEditCategory={(selected) => {
                  setOpenReportGroupCreate(true);
                  setSelectedCategory(selected);
                }}
              />
            ) : (
              <>
                {statusDefaultCategory === 1 && (
                  <>
                    <ReportProject
                      report={report}
                      project={project}
                      defaultCollpase={false}
                    />
                    <Divider className={classes.customDivider} />
                  </>
                )}
                {reportCategories
                  ?.filter((item) => !item.is_hidden)
                  // ?.filter((item, index) => index <= limit)
                  .map((item) => (
                    <>
                      <ReportProject
                        reportExtend={item}
                        project={project}
                        isDefault={false}
                        defaultCollpase={false}
                        handleEditCategory={(selected) => {
                          setOpenReportGroupCreate(true);
                          setSelectedCategory(selected);
                        }}
                        handleDeleteCategory={(id) => {
                          dispatch(
                            getReportCategoriesSuccess(
                              reportCategories.filter((item) => item.id !== id)
                            )
                          );
                        }}
                      />
                      <Divider className={classes.customDivider} />
                    </>
                  ))}
                {/* <InfiniteScroll
                pageStart={0}
                loadMore={loading}
                hasMore={true || false}
                loader={
                  <div className="loader" key={0}>
                    Loading ...
                  </div>
                }
                style={{ width: "100%" }}
              >
               
              </InfiniteScroll> */}
              </>
            )}
          </Grid>
        </Grid>
        <TimeRangePopover
          bgColor={bgColor}
          anchorEl={timeAnchor}
          setAnchorEl={setTimeAnchor}
          handleTimeRange={(timeOption, start, end) => {
            setTimeFilterReport({ timeOption, start, end });
          }}
        />
        {openReportGroupCreate && (
          <ReportGroupCreation
            open={openReportGroupCreate}
            setOpen={setOpenReportGroupCreate}
            projectId={projectId}
            selectedCategory={selectedCategory}
          />
        )}
        <ReportOrder
          open={openOrderModal}
          setOpen={setOpenOrderModal}
          projectId={projectId}
        />
      </StyledScrollbars>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    viewPermissions: viewPermissionsSelector(state),
  };
};

export default connect(mapStateToProps, (state) => {})(WrapperReport);
